export const listBillableEvents = `
   query listBillableEvents($filter: BillableEventsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listBillableEvents(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              meteringRecordId
              customerId
              meterId
              meterAssignmentId
              channel
              idempotencyKey
              state
              stateCreated
              reason
              attempts
              lastAttemptAt
              emittedAt
              recordType
              created
              updated
           }
           nextToken
       }
   }
`;

export const listBillableEventsByState = `
   query listBillableEventsByState($state: EmissionState!, $createdBefore: AWSDateTime, $limit: Int, $nextToken: String) {
       listBillableEventsByState(state: $state, createdBefore: $createdBefore, limit: $limit, nextToken: $nextToken) {
           items {
              id
              meteringRecordId
              customerId
              meterId
              meterAssignmentId
              channel
              idempotencyKey
              state
              stateCreated
              reason
              attempts
              lastAttemptAt
              emittedAt
              recordType
              created
              updated
           }
           nextToken
       }
   }
`;

export const listBillableEventsByChannelAndDay = `
   query listBillableEventsByChannelAndDay($channel: String!, $dayStart: AWSDateTime!, $dayEnd: AWSDateTime!, $limit: Int, $nextToken: String) {
       listBillableEventsByChannelAndDay(channel: $channel, dayStart: $dayStart, dayEnd: $dayEnd, limit: $limit, nextToken: $nextToken) {
           items {
              id
              meteringRecordId
              customerId
              meterId
              meterAssignmentId
              channel
              idempotencyKey
              state
              stateCreated
              reason
              attempts
              lastAttemptAt
              emittedAt
              recordType
              created
              updated
           }
           nextToken
       }
   }
`;

export const getBillableEvent = `
   query getBillableEvent($id:ID!) {
       getBillableEvent(id:$id) {
         id
         meteringRecordId
         customerId
         meterId
         meterAssignmentId
         channel
         channelPayload
         idempotencyKey
         state
         stateCreated
         reason
         attempts
         lastAttemptAt
         channelResponse
         emittedAt
         recordType
         created
         updated
       }
}`;

// FNP-663 (FNP-644 part 2): the admin requeue trigger. Async — emits a bus event the
// aggregator consumes to re-resolve the corrected assignment, rebuild the payload, rotate
// the key, and flip the row FAILED -> PENDING. Returns an ack; the row state lands later
// (the list is refreshed after).
export const requestBillableEventRequeue = `
   mutation requestBillableEventRequeue($id: ID!) {
       requestBillableEventRequeue(id: $id) {
         id
         accepted
       }
}`;
